import * as React from "react";

export const BorderLeftSVG = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" fill="white"/>
    <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="1.25" stroke="#7D8492" stroke-opacity="0.3" stroke-width="1.5"/>
    <mask id="path-3-inside-1_3949_5106" fill="white">
    <path d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z"/>
    </mask>
    <path d="M0 0H16H0ZM16 16H0H16ZM2 16C0.0670034 16 -1.5 14.433 -1.5 12.5V3.5C-1.5 1.567 0.0670034 0 2 0C1.72386 0 1.5 0.895431 1.5 2V14C1.5 15.1046 1.72386 16 2 16ZM16 0V16V0Z" fill={`${props.color ? props.color : "#052f35 "}`} mask="url(#path-3-inside-1_3949_5106)"/>
    </svg>
    
);
